<template>
  <div class="about">
    <section class="mw-800">
      <h1>Bibliografía</h1>
      <p>
        Bolton, Robert & Grover Bolton, Dorothy. (1996) People styles at work.
        Amazom. New York, USA. (nombre en español “No hay personas dificiles”)
      </p>
      <p>
        Jung, Carl. (1995). Tipos psicológicos. Editorial Sudamericana. Buenos
        Aires
      </p>
      <p>
        Costa, Carlos. (1986). Temas de psicología junguiana. Editorial El
        Ateneo. Buenos Aires, Argentina
      </p>
      <p>
        Lersch, Philipp. (1971). La estructura de la personalidad. Scientia.
        Barcelona, España
      </p>
      <p class="message">
        <a href="https://github.com/Marfullsen/estilos-sociales"
          >Fork on github<i class="small material-icons">web</i></a
        >
      </p>
    </section>
  </div>
</template>

<style scoped>
p {
  font-size: x-large !important;
}

.about {
  display: flex;
  justify-content: center;
}

.mw-800 {
  max-width: 800px;
}
</style>
